import { Info } from "lucide-react";

export default function PlaceholderNote({ children, className = "" }) {
  return (
    <div
      data-testid="placeholder-note"
      className={`flex items-start gap-3 rounded-sm border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 ${className}`}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <p>{children}</p>
    </div>
  );
}
